import { DebtMetricCardProps } from '../../types/debt.type';
import VarianceIndicator from '../home/varianceIndicator';
import Description from '../home/description';

export default function DebtMetricCard({
  value,
  label,
  filters,
  variance,
  trendUp,
}: DebtMetricCardProps) {
  const hasFilters = filters && Object.keys(filters).length > 0;
  return (
    <div className="bg-white rounded-lg w-full">
      <div className="flex flex-col gap-2 py-3 items-center justify-center h-full text-center">
        <div className="flex flex-col lg:flex-row items-center gap-3 text-center">
          <p className="text-2xl font-bold text-secondary leading-tight">
            {value}
          </p>
          {variance && trendUp && (
          <VarianceIndicator variance={variance} trendUpward={trendUp} />
          )}
        </div>
        {hasFilters ? (
          <Description description={label} descriptionFilters={filters} />
        ) : (<span className="leading-none font-thin text-xs">{label}</span>)}
      </div>
    </div>
  );
}
